import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DensityMedium from '@mui/icons-material/DensityMedium';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
//import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from "react-redux";
import {useEffect } from "react";
import { downloadUserSessionsExcelFile } from "./services/Service"
//import useMediaQuery from '@mui/material/useMediaQuery';

const drawerWidth = 240;

function NavigationMenu(props) {
  // let dispatch = useDispatch();
  //const { window } = props;
  const { window: muiWindow } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [userRoles, setUserRoles] = React.useState([]);
  const navigate=useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // const matches = useMediaQuery('(min-width:600px)');
  // const [isMobile, ] = React.useState(<span>{`(min-width:600px) matches: ${matches}`}</span>);

  const sessionToken=sessionStorage.getItem('userToken')===undefined || sessionStorage.getItem('userToken')===null?"":sessionStorage.getItem('userToken');
  const tokenDateTime=sessionStorage.getItem('tokenDateTime')===undefined || sessionStorage.getItem('tokenDateTime')===null?"":sessionStorage.getItem('tokenDateTime');
  useEffect(() => {
  if(sessionToken==="" || tokenDateTime==="")
    navigate("/login");
  if(userRoles.length===0)
    setUserRoles(JSON.parse(sessionStorage.getItem('userroles')));
  }, [navigate,sessionToken,tokenDateTime,userRoles]);

  const downloadUserSessions = async () => {
    try {
        const FileSaver = require('file-saver');
        downloadUserSessionsExcelFile().then((response) => {
        var blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'userSessions.xlsx');
    });
    } catch (error) {
        console.error('Failed to download file', error);
    }
};

  const drawer = (
    <div className='bg-menu-image'>
      <div className='container-lg'>
      <Box component="img"
              sx={{display: { xs: 'block', sm: 'none' }, paddingLeft:'10px'}}
            alt="Org Image"
            src={process.env.PUBLIC_URL + "/images/decama-logo.png"} />
        
        <CloseIcon
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: 'none' }, fontSize:'44px !important' }}/></div>
      <List className='menu-text'>
          <ListItem sx={{ mr: 2, display: { sm: 'none' }, height:'120px'}}>
            <ListItemButton>
              <ListItemIcon>
                {/* just for mobile device padding */}
              </ListItemIcon>
              <ListItemText primary={""} />
            </ListItemButton>
          </ListItem>

          <ListItem key={'lstMenuDashboard'} disablePadding onClick={()=>{navigate("/dashboard"); handleDrawerToggle();}}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<HomeIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"DASHBOARD"} />
            </ListItemButton>
          </ListItem>
          <ListItem key={'lstMenuWheelGuide'} disablePadding onClick={()=>{navigate("/wheelguide"); handleDrawerToggle();}}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<MenuIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"WHEEL GUIDE"} />
            </ListItemButton>
          </ListItem>
          <ListItem key={'lstMenuNewWheel'} disablePadding onClick={()=>{navigate("/survey"); handleDrawerToggle();}}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<MenuIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"START A NEW WHEEL"} />
            </ListItemButton>
          </ListItem>
          <ListItem key={'lstMenuPreviousData'} disablePadding onClick={()=>{navigate("/wheelguide")}} sx={{display: 'none' }}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<MenuIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"VIEW PREVIOUS DATA"} />
            </ListItemButton>
          </ListItem>
          <ListItem key={'lstMenuAllScores'} disablePadding onClick={()=>{navigate("/scorelines")}}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<MenuIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"VIEW ALL SCORES"} />
            </ListItemButton>
          </ListItem>
          <ListItem 
            key={'lstMenuTotalScores'} 
            disablePadding 
            onClick={()=>{navigate("/totalscores"); handleDrawerToggle();}}
          >
          <ListItemButton>
              <ListItemIcon>
                {/* icon optional */}
              </ListItemIcon>
              <ListItemText primary={"TOTAL SCORES"} />
            </ListItemButton>
          </ListItem>


          {userRoles.includes("Admin") &&(<ListItem key={'lstMenuDownloadUserSessions'} disablePadding onClick={downloadUserSessions}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<SaveIcon />} */}
              </ListItemIcon>
              <ListItemText primary={"DOWNLOAD USER SESSIONS"} />
            </ListItemButton>
          </ListItem>)}

          <ListItem
            key={'lstMenuArrangeCall'}
            disablePadding
            onClick={() => {
              window.open(
              'https://www.decama.co.uk/contact/',
              '_blank'
            );
            }}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* optional icon */}
              </ListItemIcon>
              <ListItemText primary={"ARRANGE A CALL"} />
            </ListItemButton>
          </ListItem>

          <ListItem
            key={'lstMenuVisitWebsite'}
            disablePadding
            onClick={() => {
              window.open(
              'https://decama.co.uk/',
              '_blank'
            );
            }}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* optional icon */}
              </ListItemIcon>
              <ListItemText primary={"VISIT OUR WEBSITE"} />
            </ListItemButton>
          </ListItem>


          <ListItem key={'lstMenuLogOut'} disablePadding onClick={()=>{navigate("/redirector")}}>
            <ListItemButton>
              <ListItemIcon>
                {/* {<LogoutIcon />} */}
              </ListItemIcon>
              {/* <ListItemText className='full-width-button' primary={"Logout"} sx={{display: { xs: 'none', sm: 'block' }}} /> */}
              <Button variant="outlined" sx={{display: { xs: 'none', sm: 'block' }}}>
                LOGOUT
            </Button>
            </ListItemButton>
          </ListItem>
      </List>

      <Box
          width='100%'
          display='flex'
          justifyContent='center'
          className="bottom-mini-device-Button"
          sx={{display: { xs: 'block', sm: 'none' }}}
          >
              <Box component="img"
              justifyContent='center'
                    sx={{display: { xs: 'block', sm: 'none' }, paddingLeft:'20px',paddingRight:'20px', width:'100%'}}
                    alt="Org Image"
                    src={process.env.PUBLIC_URL + "/images/logout-button.png"}
                    onClick={()=>{navigate("/redirector")}}
                    />
         </Box>
    </div>
  );
  
  //const container = window !== undefined ? () => window().document.body : undefined;
  const container = muiWindow !== undefined
  ? () => muiWindow().document.body
  : undefined;
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        >
        <Toolbar >
        <Box component="img"
              sx={{display: { xs: 'none', sm: 'block' }}}
            alt="Org Image"
            src={process.env.PUBLIC_URL + "/images/blank.png"} />
            <Box component="img"
              sx={{
                //height: 80,
                //maxHeight: { xs: 100, md: 90 },
                }}
            alt="Org Image"
            src={process.env.PUBLIC_URL + "/images/decama-logo.png"} />
          
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
            >
            <DensityMedium
            style={{fontSize:"40px"}}
            />
          </IconButton>
          <Box component="img"
              sx={{display: { xs: 'none', sm: 'block' }}}
            alt="Org Image"
            src={process.env.PUBLIC_URL + "/images/blank.png"} />
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="drawer menu">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >

          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
      </Box>
    </Box>
  );
}

NavigationMenu.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default NavigationMenu;